<template>
  <div class="game-title-wrapper" :style="getStyle()">
    <div class="new-line left" :class="{ 'padding-top': multiStage }">
      <div
        class="audio"
        v-show="audio != ''"
        style="max-width: 57px; max-height: 57px; pointer-events: auto; z-index: 1006"
      >
        <!-- <div class="audio-icon"><span>mp3</span></div> -->
        <div
          style="width: 100%; height: 100%; position: relative; cursor: pointer"
          v-if="aduioOn"
          @mouseenter="hoverOnIcon = true"
          @mouseleave="hoverOnIcon = false"
        >
          <img
            :src="aduioOn"
            style="width: 100%; height: 100%; position: absolute; object-fit: scale-down"
            v-if="!audioStatus && !hoverOnIcon"
            @click="startPlay()"
          />
          <img
            :src="aduioOnHover"
            style="width: 100%; height: 100%; position: absolute; object-fit: scale-down"
            v-if="!audioStatus && hoverOnIcon"
            @click="startPlay()"
          />
          <img
            :src="aduioOff"
            style="width: 100%; height: 100%; position: absolute; object-fit: scale-down"
            v-if="audioStatus && !hoverOnIcon"
            @click="startPlay()"
          />
          <img
            :src="aduioOffHover"
            style="width: 100%; height: 100%; position: absolute; object-fit: scale-down"
            v-if="audioStatus && hoverOnIcon"
            @click="startPlay()"
          />
        </div>
        <svg class="audio-svg-button" @click="startPlay()" viewBox="0 0 24 24" v-if="!aduioOn">
          <transition name="click-fade">
            <path
              v-if="!audioStatus"
              d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
            />
          </transition>
          <transition name="click-fade">
            <path
              v-if="audioStatus"
              d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
            />
          </transition>
        </svg>
        <!-- <font-awesome-icon :icon="icon" size="2x"></font-awesome-icon> -->
      </div>
      <div :style="setTitleBoxStyle()">
        <div class="text-style" :style="[audio != '' ? { 'max-width': '1600px' } : {}]">
          <!-- <span v-if="!katex" v-html="titleText"></span>
          <ps-text v-if="katex" :textValue="`${titleText}`" :fontSize="`${size}`"></ps-text> -->

          <div v-if="checkKatexMarker(titleText)">
            <ps-text :font-size="`${size}`" :text-value="`${titleText}`" v-if="size"></ps-text>
            <ps-text :text-value="`${titleText}`" v-else></ps-text>
            <!-- <ps-text :font-size="size" :text-value="`${titleText}`"></ps-text> -->
          </div>
          <span v-if="!checkKatexMarker(titleText)" :style="{ fontSize: size + 'px' }" v-html="`${titleText}`"></span>
        </div>
      </div>
    </div>
    <!-- <div class="new-line multi-progress" v-if="multiStage && !gameobj.withoutProgress">
      <b-progress :value="stageProgress" class="full-width"></b-progress>
    </div> -->
    <div class="new-line multi-progress" v-if="multiStage && !gameobj.withoutProgress">
      <!-- <b-progress :value="stageProgress" class="full-width"></b-progress> -->
      <div class="bar-grey"></div>
      <div class="bar-circle"></div>
      <div v-for="item in stageLenght" :key="item.id">
        <div :style="{ left: (97 / stageLenght) * item + '%' }" class="bar-circle"></div>
      </div>

      <div :style="{ float: 'left', width: 100 / stageLenght + '%' }" v-for="item in currentStage" :key="item.id">
        <div class="bar-blue"></div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { Howler } from 'howler';
import { getGamePath } from './../../Utils/pathUtils';
//import PsText from './PsText.vue';
import PsText from '../../GameEngines/TrInput/PsText';
export default {
  name: 'tr-ui-title',
  components: { PsText },
  props: {
    titleText: {
      type: String,
      default: function () {
        return '';
      },
    },
    multiStage: {
      type: Boolean,
      default: false,
    },
    progressWithCircle: {
      type: Boolean,
      default: false,
    },
    audio: {
      type: String,
      default: function () {
        return '';
      },
    },
    width: {
      type: Number,
      default: function () {
        return 1800;
      },
    },
    height: {
      type: Number,
      default: function () {
        return 115;
      },
    },
    size: {
      type: null,
      default: function () {
        // return '28px';
        //  FIXME: check if its working after merge
        return '';
      },
    },
    katex: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    pos: {
      type: Object,
      default: function () {
        return { x: 0, y: 0 };
      },
    },
    cssStyle: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    return {
      volumeValue: 1,
      sound: null,
      audioStatus: false,
      actualAudio: 0,
      openAudioBox: false,
      aduioOn: null,
      aduioOnHover: null,
      aduioOff: null,
      aduioOffHover: null,
      hoverOnIcon: false,
    };
  },
  mounted() {
    if (this.audio != '') {
      this.setAudioConfig();
      try {
        this.aduioOn = require('__mainSrcDir/config/audioIconConfig/index.js').AUDIO_ON;
        this.aduioOnHover = require('__mainSrcDir/config/audioIconConfig/index.js').AUDIO_ON_HOVER;
        this.aduioOff = require('__mainSrcDir/config/audioIconConfig/index.js').AUDIO_OFF;
        this.aduioOffHover = require('__mainSrcDir/config/audioIconConfig/index.js').AUDIO_OFF_HOVER;
      } catch {
        console.log(
          '%cAudioIcon TrUiTitle- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
    }
  },
  methods: {
    checkKatexMarker(item) {
      let flag = item.search('_#');
      if (flag == -1) {
        return false;
      }
      return true;
    },
    giveMeImagePlease(path) {
      try {
        let audioPath = getGamePath(path);
        return require(`__staticDir/${this.$store.getters.multibookType}/${audioPath}`);
      } catch (err) {
        console.log(err);
      }
    },
    setTitleBoxStyle() {
      let style = {};
      if (this.sound) style.width = 'calc(100% - 77px)';
      return style;
    },
    setAudioConfig() {
      this.sound = new Howl({
        src: this.giveMeImagePlease(this.audio),
        autoplay: false,
        loop: false,
        volume: 1,
        onend: () => {
          this.audioStatus = false;
          console.log('end');
        },
        onpause: () => {
          this.audioStatus = false;
          console.log('end');
        },
        onstop: () => {
          this.audioStatus = false;
          console.log('end');
        },
        onplay: () => {
          this.audioStatus = true;
          console.log('sztart');
        },
      });
    },
    startPlay() {
      if (!this.audioStatus) {
        this.sound.play();
        this.canIPlay = false;
        setTimeout(() => {
          this.canIPlay = true;
        }, 500);
      } else {
        this.stopPlay();
      }
    },
    stopPlay() {
      this.sound.stop();
    },
    getStyle() {
      let data = {
        left: `${this.pos.x}%`,
        top: `${this.pos.y}%`,
        width: `${this.width}px`,
        height: `${this.height}px`,
      };
      return _.assign(data, this.getCustomStyle(this.cssStyle));
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item) {
        if (_.isObject(item)) {
          customStyle = _.mapKeys(item, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
  beforeDestroy() {
    if (this.sound) this.stopPlay();
  },
  computed: {
    gameobj() {
      return this.$store.getters.gameObj;
    },
    stageProgress() {
      console.log('EEEEE', this.$store.getters.stages.length);
      return ((this.$store.getters.currentStage + 1) / this.$store.getters.stages.length) * 100;
    },
    stageLenght() {
      return this.$store.getters.stages.length;
    },
    currentStage() {
      return this.$store.getters.currentStage + 1;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/iconColor';
@import '~@/assets/sass/titleStyle';

.bar-grey {
  position: absolute;
  width: 98%;
  background: rgba(255, 255, 255, 0.4);
  height: 6px;
}
.bar-blue {
  z-index: 300;
  background: #00a2e8;
  height: 6px;
}
.bar-circle {
  margin-top: -7px;
  position: absolute;
  width: 20px;
  height: 20px;
  background: #00a2e8;
  border-radius: 50%;
}
.game-title-wrapper {
  position: absolute;
  display: flex;
  // justify-content: center;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  width: $titleContainerWidth;
  height: $titleContainerHeight;
  font-size: $titleFontSize;
  background-color: $titleBackgroundColor;
  border-radius: $titleContainerBorderRadius;
  padding-left: 40px;
  margin-left: 11px;
  margin-top: 21px;
  .new-line {
    position: relative;
    display: flex;
    height: 50%;
    width: 100%;
  }
  .left {
    justify-content: flex-start;
    align-items: center;
    text-align: left;
    .audio {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10px;
      // border: solid 1px black;
      border-radius: 50%;
      height: 57px;
      width: 57px;
      // color: $secondIconColor;
      // background-color: $firstIconColor;
      transition: 0.2s;
      .audio-svg-button {
        width: 100%;
        height: 100%;
        fill: white;
        transition: 0.2s;
        &:hover {
          fill: #00a8ec;
        }
      }
    }
    .padding-top {
      padding-top: 15px;
    }
  }
  .multi-progress {
    width: 100%;
    height: 3%;
    padding-right: 40px;
    // .full-width {
    //   width: 100%;
    //   height: 100%;
    //   .progress-bar {
    //     background-color: grey !important;
    //   }
    // }
  }
}
// HACK:title hack
/**
 * hack dla scali i przesuniecia z canvasem w cwiczeniach
 * @type {[type]}
 */

.hack-game-title-wrapper {
  transform: translate(-50%, -50%) scale(0.7) !important;
  left: 32.5% !important;
  top: 2% !important;
}
</style>
<style lang="scss">
.full-width {
  width: 100%;
  height: 100%;
  .progress-bar {
    height: 6px;
    background-color: grey !important;
  }
}
</style>
